<template>
  <vx-card :title="id === null ? 'Cadastrar Usuário' : 'Editar Usuário'">
    <vs-tabs :color="colorx">
      <vs-tab label="Usuário">
        <validation-observer ref="formobserver">
          <b-form @submit.prevent="create">
            <div class="vx-row mb-6">
              <div class="vx-col w-full mb-2">
                <label>Pessoa Natural</label>

                <!-- button on both side -->
                <b-input-group>
                  <b-form-input v-model="naturalEntity.full_name" readonly />
                  <b-input-group-append>
                    <b-button
                      variant="outline-primary"
                      @click="showNaturalEntitySearchGrid = true"
                    >
                      <feather-icon icon="SearchIcon" class="mr-50" />
                      <span class="align-middle">Buscar</span>
                    </b-button>
                    <b-button
                      variant="outline-primary"
                      @click="showNaturalEntityCreateForm = true"
                    >
                      <feather-icon icon="PlusIcon" class="mr-50" />
                      <span class="align-middle">Incluir</span>
                    </b-button>
                    <b-button
                      variant="outline-primary"
                      @click="naturalEntity = {}"
                    >
                      <feather-icon icon="XIcon" class="mr-50" />
                      <span class="align-middle">Limpar</span>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <b-form-group label="E-mail" label-for="surname">
                  <validation-provider
                    #default="{ errors }"
                    name="E-mail"
                    rules="required|email"
                  >
                    <b-form-input
                      id="email"
                      v-model="userEmail"
                      :state="errors.length > 0 ? false : null"
                      name="email"
                      class="required"
                    />
                    <b-form-invalid-feedback>
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>

                <!-- <span class="text-danger text-sm" v-show="errors.has('email')">{{
                  errors.first('email')
                }}</span> -->
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-full">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-secondary"
                  @click="cancel"
                  class="mt-5 float-right"
                >
                  Cancelar
                </b-button>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mt-5 mr-2 float-right"
                  :disabled="!validateForm"
                  type="submit"
                >
                  Salvar
                </b-button>
              </div>
            </div>
          </b-form>
        </validation-observer>
      </vs-tab>
      <vs-tab label="Grupos" v-if="id !== null">
        <div class="vx-row mb-6" style="padding-top: 30px">
          <div class="vx-col w-full">
            <div class="flex justify-end">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                @click="showModal = true"
              >
                <feather-icon icon="PlusIcon" class="mr-50" />
                <span class="align-middle">{{ $t('add') }}</span>
              </b-button>
              <b-button
                variant="outline-secondary"
                class="float-right"
                @click="cancel"
              >
                <feather-icon icon="CornerUpLeftIcon" class="mr-50" />
                <span class="align-middle">{{ $t('back') }}</span>
              </b-button>
            </div>
            <vs-divider />
            <Grid
              ref="grid"
              :service="roleService"
              route_name="roles"
              :route_grid_path="userRolesPath"
              :route_delete_path="userRolesPath"
              hide_edit="true"
              :delegate="{ destroy: () => destroyRoleUser }"
            ></Grid>
          </div>
        </div>
      </vs-tab>
      <vs-tab label="Logs de acesso" v-if="id !== null">
        <div class="vx-row mb-6" style="padding-top: 30px">
          <div class="vx-col w-full">
            <Grid
              ref="accessLogsGrid"
              :service="userService"
              route_name="users"
              :route_grid_path="userAccessLogsPath"
              hide_actions="true"
              order_column="login_at"
              direction="desc"
              :css_formats="{
                status: (status, model) => {
                  if (status === 'success') {
                    return 'badge badge-glow badge-success'
                  } else if (status === 'failed') {
                    return 'badge badge-glow badge-danger'
                  } else if (status === 'unauthorized') {
                    return 'badge badge-glow badge-warning'
                  }
                  return ''
                }
              }"
              :column_formats="{
                status: val => {
                  if (val === 'success') {
                    return this.$t('last_access.status.success')
                  } else if (val === 'failed') {
                    return this.$t('last_access.status.failed')
                  } else if (val === 'unauthorized') {
                    return this.$t('last_access.status.unauthorized')
                  }
                  return val || ''
                }
              }"
            >
              <template v-slot:gridThead>
                <vs-th key="id" sort-key="id">{{ $t('grid.id') }}</vs-th>
                <vs-th key="status" sort-key="status">{{
                  $t('grid.status')
                }}</vs-th>
                <vs-th key="ip_address" sort-key="ip_address">{{
                  $t('last_access.ip')
                }}</vs-th>
                <vs-th key="device_type" sort-key="device_type">{{
                  $t('last_access.device')
                }}</vs-th>
                <vs-th key="browser" sort-key="browser">{{
                  $t('last_access.browser')
                }}</vs-th>
                <vs-th key="platform" sort-key="platform">{{
                  $t('last_access.platform')
                }}</vs-th>
                <vs-th key="login_at_formatted" sort-key="login_at">{{
                  $t('last_access.date_time')
                }}</vs-th>
                <vs-th key="logout_at_formatted" sort-key="logout_at">{{
                  $t('last_access.logout_at')
                }}</vs-th>
              </template>
              <template v-slot:gridData="props">
                <vs-tr
                  :data="tr"
                  :key="indextr"
                  v-for="(tr, indextr) in props.data"
                >
                  <vs-td key="id">
                    <div>{{ tr.id }}</div>
                  </vs-td>
                  <vs-td key="status">
                    <div :class="getStatusBadgeClass(tr.status)">
                      {{ getStatusLabel(tr.status) }}
                    </div>
                  </vs-td>
                  <vs-td key="ip_address">
                    <div>{{ tr.ip_address }}</div>
                  </vs-td>
                  <vs-td key="device_type">
                    <div>{{ tr.device_type }}</div>
                  </vs-td>
                  <vs-td key="browser">
                    <div>{{ tr.browser }}</div>
                  </vs-td>
                  <vs-td key="platform">
                    <div>{{ tr.platform }}</div>
                  </vs-td>
                  <vs-td key="login_at_formatted">
                    <div>{{ tr.login_at_formatted }}</div>
                  </vs-td>
                  <vs-td key="logout_at_formatted">
                    <div>{{ tr.logout_at_formatted }}</div>
                  </vs-td>
                </vs-tr>
              </template>
            </Grid>
          </div>
        </div>
      </vs-tab>
    </vs-tabs>

    <vs-popup title="Grupos" :active.sync="showModal">
      <Grid
        :service="roleService"
        :delegate="{ itemSelected: () => itemSelected }"
        route_name="/roles"
        v-if="showModal"
        hide_actions="true"
      ></Grid>
    </vs-popup>

    <vs-popup
      fullscreen
      iconPack="material-icons"
      title="Cadastrar Usuário"
      :active.sync="showNaturalEntityCreateForm"
    >
      <NaturalEntityForm
        @close="closeNaturalEntityPopup"
        :services="services"
        :naturalEntityId="null"
        hide_spouse="true"
      />
    </vs-popup>

    <vs-popup title="Pessoa Natural" :active.sync="showNaturalEntitySearchGrid">
      <Grid
        :service="services.naturalEntityService"
        route_name="natural_entities"
        hide_actions="true"
        :delegate="{ itemSelected: () => naturalEntitySelected }"
      ></Grid>
    </vs-popup>
  </vx-card>
</template>

<script>
import UserService from '@/services/api/UserService'
import RoleService from '@/services/api/RoleService'
import FederationUnitService from '@/services/api/FederationUnitService'
import CityService from '@/services/api/CityService'
import PeopleService from '@/services/api/PeopleService'
import NaturalEntityService from '@/services/api/NaturalEntityService'
import PronounTreatmentService from '@/services/api/PronounTreatmentService'

import NaturalEntityForm from '@/views/apps/people/tabs/NaturalEntityForm.vue'
import {
  BForm,
  BButton,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BFormInvalidFeedback
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    NaturalEntityForm,
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    // Validation
    ValidationProvider,
    ValidationObserver,
    BFormInvalidFeedback
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    id: null,
    userEmail: '',
    naturalEntity: {},
    showModal: false,
    roleService: null,
    userService: null,
    services: {
      federationUnitService: null,
      cityService: null,
      peopleService: null,
      naturalEntityService: null,
      pronounTreatmentService: null
    },
    showNaturalEntitySearchGrid: false,
    showNaturalEntityCreateForm: false,
    // validation rules
    required
  }),
  computed: {
    userRolesPath() {
      return `/user/${this.id}`
    },
    userAccessLogsPath() {
      return `/${this.id}/access-logs/grid`
    },
    validateForm() {
      return 'id' in this.naturalEntity && this.userEmail !== ''
    }
  },
  methods: {
    getStatusBadgeClass(status) {
      if (status === 'success') {
        return 'badge badge-glow badge-success'
      } else if (status === 'failed') {
        return 'badge badge-glow badge-danger'
      } else if (status === 'unauthorized') {
        return 'badge badge-glow badge-warning'
      }
      return ''
    },
    getStatusLabel(status) {
      if (status === 'success') {
        return this.$t('last_access.status.success')
      } else if (status === 'failed') {
        return this.$t('last_access.status.failed')
      } else if (status === 'unauthorized') {
        return this.$t('last_access.status.unauthorized')
      }
      return status || ''
    },
    closeNaturalEntityPopup() {
      this.showNaturalEntityCreateForm = false
    },
    itemSelected(role) {
      if (role) {
        this.$vs.loading()
        this.roleService.attachRoleUser(role.id, this.id).then(
          response => {
            this.$vs.loading.close()
            this.notifySuccess(this.$vs)

            if ('grid' in this.$refs) {
              this.$refs.grid.fetchGridData()
            }
          },
          error => {
            this.$vs.loading.close()
            this.notifyError(this.$vs, 'Não foi possível incluir este grupo!')
          }
        )
      }
      this.showModal = false
    },
    destroyRoleUser(role) {
      this.$vs.loading()
      return this.roleService.destroyRoleUser(role.id, this.id).then(
        response => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Successo!',
            text: 'Operação realizada com sucesso.',
            color: 'success',
            iconPack: 'feather',
            position: 'top-center',
            icon: 'icon-check-circle'
          })

          return { reload: true }
        },
        error => {
          this.$vs.loading.close()
          this.notifyError(this.$vs, 'Não foi possível escluir este grupo!')
        }
      )
    },
    create() {
      this.clearErrors(this.$refs.formobserver)
      this.$vs.loading()

      const userService = UserService.build(this.$vs)
      let promise = null

      const data = {
        email: this.userEmail,
        name: this.naturalEntity.full_name,
        natural_entity_id: this.naturalEntity.id
      }

      if (this.isEmpty(this.id)) {
        promise = userService.internalStore(data)
      } else {
        data['id'] = this.id
        promise = userService.update(data)
      }

      promise.then(
        data => {
          this.id = data.id
          this.$vs.loading.close()

          this.notifySuccess(this.$vs)

          this.$router.push(`/users/${data.id}/edit`)
        },
        error => {
          this.$vs.loading.close()
          this.showErrors(this.$refs.formobserver, error, this)
        }
      )
    },
    cancel() {
      this.$router.push('/users')
    },
    getData(id) {
      this.$vs.loading()
      const service = UserService.build(this.$vs)
      service.read(id).then(
        data => {
          this.$set(this.$data, 'id', data.id)
          this.$set(this.$data, 'userEmail', data.email)
          this.$set(this.$data, 'naturalEntity', data.natural_entity)

          this.$vs.loading.close()
        },
        error => {
          this.$vs.loading.close()
        }
      )
    },
    naturalEntitySelected(naturalEntity) {
      this.naturalEntity = naturalEntity
      this.showNaturalEntitySearchGrid = false
    },
    naturalEntityCreated(naturalEntity) {
      this.naturalEntity = naturalEntity
      this.closeNaturalEntityPopup()
    }
  },
  created() {
    this.roleService = RoleService.build(this.$vs)
    this.userService = UserService.build(this.$vs)
    if (this.id) {
      this.getData(this.id)
    }
  },
  beforeMount() {
    this.services.federationUnitService = FederationUnitService.build(this.$vs)
    this.services.cityService = CityService.build(this.$vs)
    this.services.peopleService = PeopleService.build(this.$vs)
    this.services.peopleService = PeopleService.build(this.$vs)
    this.services.naturalEntityService = NaturalEntityService.build(this.$vs)
    this.services.pronounTreatmentService = PronounTreatmentService.build(
      this.$vs
    )
  },
  mounted() {
    this.$root.$on('naturalEntityCreated', this.naturalEntityCreated)
  },
  beforeDestroy() {
    this.$root.$off('naturalEntityCreated', this.naturalEntityCreated)
  }
}
</script>
